<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <card-component titulo="Lista dos pacientes" componente="null" usuario="null">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col-8 mb-3">
                                <input-container-component titulo="Nome" id="inputNome">
                                    <input type="text" class="form-control" id="inputNome" placeholder="Informe o Nome"
                                        v-model="busca.nome" @keyup="pesquisar()">
                                </input-container-component>
                            </div>
                            <div class="col-2" v-if="userJson.nivel_acesso != 'adm'">
                                <button type="button" class="btn btn-success btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalExportarCXXLS">
                                    Exportar Caixinha XLS
                                </button>
                            </div>
                            <div class="col-2">
                                <button type="button" class="btn btn-secondary btn-sm float-end" data-bs-toggle="modal"
                                    data-bs-target="#modalVisualizarDepositos">
                                    Depósitos
                                </button>
                            </div>
                        </div>
                        <table-component :dados="pacientes.data" componentpai="caixa"
                            :anomes="new Date().toISOString().slice(0, 7)" :rateio="{
                                visivel: true,
                                dataToggle: 'modal',
                                dataTarget: '#modalRateioCaixa'
                            }" :depositos="{
                                visivel: true,
                                dataToggle: 'modal',
                                dataTarget: '#modalDepositos'
                            }" :titulos="{
                                id: { titulo: '', tipo: '' },
                                nome: { titulo: 'Nome', tipo: 'texto' },
                                centro_custo: { titulo: 'Centro Custo', tipo: 'texto' },
                                status: { titulo: 'Status', tipo: 'texto' },
                                caps: { titulo: 'Caps Paciente', tipo: '' },
                                conta_contabil_reduzido: { titulo: '', tipo: '' }
                            }"></table-component>
                    </template>
                    <template v-slot:rodape>
                        <div class="row">
                            <paginate-component>
                                <li v-for="l, key in pacientes.links" :key="key"
                                    :class="l.active ? 'page-item active' : 'page-item'"><a class="page-link"
                                        v-html="l.label" @click="paginacao(l)"></a></li>
                            </paginate-component>
                        </div>
                    </template>
                </card-component>
            </div>
        </div>

        <modal-component id="modalRateioCaixa" titulo="Rateio Caixinha" tipomodal="modal-lg">
            <template v-slot:alertas>
            </template>
            <template v-slot:conteudo>
                <div class="row" v-if="userJson.nivel_acesso == 'adm'">
                    <h2>Exportar lançamentos</h2>
                    <div class="col-3">
                        <div class="form-group">
                            <input-container-component titulo="Inicio">
                                <input type="date" name="inicioRel" id="inicioRel" class="form-control"
                                    v-model="inicioRel">
                            </input-container-component>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <input-container-component titulo="Fim">
                                <input type="date" name="fimRel" id="fimRel" class="form-control" v-model="fimRel">
                            </input-container-component>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <input-container-component titulo="">
                                <button type="button" class="btn btn-primary" @click="exportaLan"
                                    v-if="$store.state.item && inicioRel && fimRel">Exportar</button>
                            </input-container-component>
                        </div>
                    </div>
                    <br>
                    <hr>
                </div>
                <div class="row">
                    <div class="col-2">
                        <div class="form-group">
                            <input-container-component titulo="Ano Caixa">
                                <select name="anoCaixa" class="form-control" id="anoCaixa" v-model="ano_rel"
                                    @change="filtroRel">
                                    <option value="2025">2025</option>
                                    <option value="2026">2026</option>
                                </select>
                            </input-container-component>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <input-container-component titulo="Mês Caixa">
                                <select name="mesCaixa" class="form-control" id="mesCaixa" v-model="mes_rel"
                                    @change="filtroRel">
                                    <option value="01">Janeiro</option>
                                    <option value="02">Fevereiro</option>
                                    <option value="03">Março</option>
                                    <option value="04">Abril</option>
                                    <option value="05">Maio</option>
                                    <option value="06">Junho</option>
                                    <option value="07">Julho</option>
                                    <option value="08">Agosto</option>
                                    <option value="09">Setembro</option>
                                    <option value="10">Outubro</option>
                                    <option value="11">Novembro</option>
                                    <option value="12">Dezembro</option>
                                </select>
                            </input-container-component>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group">
                            <input-container-component titulo="Saldo Atual Caixinha">
                                <p>{{ $store.state.saldoRelAtual | formatCurrency }}</p>
                            </input-container-component>
                        </div>
                    </div>
                    <div class="col-2">
                        <a v-if="$store.state.item.cx && ano_rel && mes_rel"
                            :href="'https://contasmoradores.candido.org.br/extrato/' + ano_rel + '-' + mes_rel + '/' + $store.state.relatorio_id"
                            target="_blank" class="btn btn-outline-primary float-end" style="font-size: 11px;">Extrato
                            Caixinha</a>
                    </div>
                    <div class="col-2">
                        <button type="button" class="btn btn-primary btn-sm mb-2 float-end"
                            @click="exportarXLSX($store.state.item.cx)" v-if="$store.state.item && ano_rel && mes_rel">
                            ExportarXLSX
                        </button>
                    </div>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-outline-primary btn-sm mb-2"
                        style="width: 60%; margin: 10px auto;" @click="recalcularSaldos">
                        Recalcular Saldo
                    </button>
                </div>
                <div class="mt-5">
                    <p><b>Paciente: {{ $store.state.nome_rel_paciente ?? '' }}</b></p>
                    <p>Extrato Caixinha</p>
                    <table class="table table-success table-striped table-hover">
                        <thead>
                            <tr style="font-size: 12px;"><!-- class="text-uppercase" -->
                                <th scope="col">Descrição</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Saldo</th>
                                <th scope="col">Data</th>
                                <th scope="col">Operação</th>
                                <th scope="col">ID Lançamento</th>
                            </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                            <tr v-for="(item, index) in $store.state.item.cx" :key="index" :class="item.tipo_operacao">
                                <td>{{ item.descricao }}</td>
                                <td>R$ {{ item.valor_paciente }}</td>
                                <td>{{ item.saldo | formatCurrency }}</td>
                                <td>{{ item.data_lancamento | formataDataGlobal }}</td>
                                <td>{{ item.tipo_operacao }}</td>
                                <td>{{ item.lan_desc_cx_id }}</td>
                            </tr>
                            <tr>
                                <td colspan="1"><b>Total Entrada: </b>R${{ resultado.entrada }}</td>
                                <td colspan="1"><b>Total Saida: </b>R${{ resultado.saida }}</td>
                                <td colspan="3"></td>
                                <td colspan="3"></td>
                            </tr>
                        </tbody>
                    </table>
                    <hr>
                    <p>Extrato Banco do Brasil</p>
                    <table class="table table-success table-striped table-hover">
                        <thead>
                            <tr style="font-size: 12px;"><!-- class="text-uppercase" -->
                                <th scope="col">Valor</th>
                                <th scope="col">Data</th>
                                <th scope="col">ID Lançamento</th>
                            </tr>
                        </thead>
                        <tbody style="font-size: 12px;">
                            <tr v-for="(item, index) in $store.state.item.bb" :key="index" class="saida">
                                <td>R$ {{ item.valor_paciente }}</td>
                                <td>{{ item.created_at | formataDataGlobal }}</td>
                                <td>{{ item.lan_desc_id }}</td>
                            </tr>
                            <tr>
                                <td colspan="3"><b>Total: </b>R${{ totalBB | formatCurrency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template v-slot:rodape>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
            </template>
        </modal-component>
        <!-- #######################################################################################################################
####################################################################################################################### -->
        <modal-component id="modalDepositos" titulo="Depósitos" tipomodal="modal">
            <template v-slot:conteudo>
                <div class="row">
                    <button class="btn btn-primary btn-sm float-end" style="margin-right: 5px;"
                        @click="adicionarComprovante = true">Adicionar</button>
                </div>
                <div class="row" v-if="adicionarComprovante">
                    <h4>Adicionar</h4>
                    <div class="form-group mt-3">
                        <input-container-component titulo="Valor Deposito" id="novoValorDeposito">
                            <input type="number" class="form-control" id="novoValorDeposito"
                                placeholder="Informe o Valor Deposito" v-model="valor_deposito">
                        </input-container-component>
                    </div>
                    <div class="form-group mt-3"">
                            <input-container-component titulo=" Data Deposito" id="data_deposito">
                        <input type="date" class="form-control" id="data_deposito" v-model="data_deposito">
                        </input-container-component>
                    </div>
                    <div class="row mt-3"">
                        <div class=" col">
                        <label class="custom-file-upload float-start">
                            <input type="file" style="display: none" @change="carregarComprovanteDeposito($event)"
                                id="inputImagem" name="imagem" />
                            <a class="btn btn-outline-primary btn-sm d-inline"> Comprovante Deposito </a>
                        </label>
                        <p v-if="arquivo_carregado" class="text-success mt-2 mb-2 float-start">
                            Arquivo carregado: {{ arquivo_carregado }}
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <button type="button" class="btn btn-primary" @click="salvarDepositoCandido()">Salvar</button>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-secondary"
                            @click="adicionarComprovante = false">Cancelar</button>
                    </div>
                </div>
                <hr>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-group">
                <input-container-component titulo="Ano Deposito">
                    <select name="anoDeposito" class="form-control" id="anoDeposito" v-model="ano_deposito"
                        @change="filtroRelComp">
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                    </select>
                </input-container-component>
            </div>
        </div>
        <div class="col">
            <div class="form-group">
                <input-container-component titulo="Mês Deposito">
                    <select name="mesDeposito" class="form-control" id="mesDeposito" v-model="mes_deposito"
                        @change="filtroRelComp">
                        <option value="01">Janeiro</option>
                        <option value="02">Fevereiro</option>
                        <option value="03">Março</option>
                        <option value="04">Abril</option>
                        <option value="05">Maio</option>
                        <option value="06">Junho</option>
                        <option value="07">Julho</option>
                        <option value="08">Agosto</option>
                        <option value="09">Setembro</option>
                        <option value="10">Outubro</option>
                        <option value="11">Novembro</option>
                        <option value="12">Dezembro</option>
                    </select>
                </input-container-component>
            </div>
        </div>
    </div>
    <div class="row">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">Valor</th>
                    <th scope="col">Data</th>
                    <th scope="col">Comprovante</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="deposito in $store.state.depositos.data" :key="deposito.id">
                    <td>R$ {{ deposito.valor }}</td>
                    <td>{{ deposito.data | formataDataGlobal }}</td>
                    <td><a :href="'https://contasmoradores.candido.org.br/storage/' + deposito.comprovante"
                            target="_blank" class="btn btn-outline-primary float-end"
                            style="font-size: 11px; margin-right: 5px;">PDF</a></td>
                    <td><button class="btn btn-danger btn-sm float-end" style="margin-right: 5px;"
                            @click="removerComprovante(deposito.id)">Remover</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<template v-slot:rodape>
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
</template>
</modal-component>
<!-- #######################################################################################################################
####################################################################################################################### -->
<modal-component id="modalExportarCXXLS" titulo="Exportar XLS" tipomodal="modal-xl">
    <template v-slot:conteudo>
        <div class="row">
            <div class="col">
                <input-container-component titulo="Data Inicio" id="data_txt_inicio">
                    <input type="date" class="form-control" id="data_txt_inicio" v-model="dtXlsInicio">
                </input-container-component>
            </div>
            <div class="col">
                <input-container-component titulo="Data Fim" id="data_txt_fim">
                    <input type="date" class="form-control" id="data_txt_fim" v-model="dtXlsFim">
                </input-container-component>
            </div>
            <div class="col">
                <input-container-component titulo="">
                    <a :href="'https://contasmoradores.candido.org.br/exportar/cx_indv/' +
                        dtXlsInicio + '/' + dtXlsFim" class="btn btn-secondary float-end"
                        style="font-size: 11px;">Exportar XLS</a>
                </input-container-component>
            </div>
        </div>
    </template>
    <template v-slot:rodape>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
    </template>
</modal-component>
<!-- #######################################################################################################################
####################################################################################################################### -->
<modal-component id="modalVisualizarDepositos" titulo="Depósitos" tipomodal="modal-xl">
    <template v-slot:conteudo>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <input-container-component titulo="Ano Deposito">
                        <select name="anoDeposito" class="form-control" id="anoDeposito" v-model="ano_deposito_hist"
                            @change="filtroRelHistComp">
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                        </select>
                    </input-container-component>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <input-container-component titulo="Mês Deposito">
                        <select name="mesDeposito" class="form-control" id="mesDeposito" v-model="mes_deposito_hist"
                            @change="filtroRelHistComp">
                            <option value="01">Janeiro</option>
                            <option value="02">Fevereiro</option>
                            <option value="03">Março</option>
                            <option value="04">Abril</option>
                            <option value="05">Maio</option>
                            <option value="06">Junho</option>
                            <option value="07">Julho</option>
                            <option value="08">Agosto</option>
                            <option value="09">Setembro</option>
                            <option value="10">Outubro</option>
                            <option value="11">Novembro</option>
                            <option value="12">Dezembro</option>
                        </select>
                    </input-container-component>
                </div>
            </div>
        </div>
        <div class="row">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Nome Paciente</th>
                        <th scope="col">Valor</th>
                        <th scope="col">Data</th>
                        <th scope="col">Conta Contabil</th>
                        <th scope="col">Caps</th>
                        <th scope="col">Comprovante</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="deposito in historico_depositos.data" :key="deposito.id">
                        <td>{{ deposito.nome_paciente }}</td>
                        <td>R$ {{ deposito.valor }}</td>
                        <td>{{ deposito.data | formataDataGlobal }}</td>
                        <td>{{ deposito.paciente.conta_contabil_reduzido }}</td>
                        <td>{{ deposito.caps.nome }}</td>
                        <td><a :href="'https://contasmoradores.candido.org.br/storage/' + deposito.comprovante"
                                target="_blank" class="btn btn-outline-primary float-end"
                                style="font-size: 11px; margin-right: 5px;">PDF</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </template>
    <template v-slot:rodape>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
    </template>
</modal-component>

<div v-if="load_update" class="overlay">
    <div class="spinner">Processando...</div>
</div>
</div>
</template>

<script>
import * as XLSX from "xlsx";
export default {
    props: ['user'],
    data() {
        return {
            urlBase: 'https://contasmoradores.candido.org.br/api/v1/paciente-cx',
            urlPaginacao: '',
            urlFiltro: '',
            pacientes: { data: [] },
            busca: { nome: '' },
            links: {},
            ano_rel: '',
            mes_rel: '',
            resultado: {
                entrada: 0,
                saida: 0
            },
            totalBB: 0,
            dataAtual: new Date().toISOString().slice(0, 10),
            inicioRel: '',
            fimRel: '',
            adicionarComprovante: false,
            valor_deposito: '',
            data_deposito: '',
            comprovante_deposito: '',
            arquivo_carregado: '',
            ano_deposito: '',
            mes_deposito: '',
            historico_depositos: {},
            ano_deposito_hist: '',
            mes_deposito_hist: '',
            dtXlsInicio: '',
            dtXlsFim: '',
            historico_depositos: '',
            load_update: false
        }
    },
    methods: {
        salvarDepositoCandido() {
            let formData = new FormData()
            formData.append('nome_paciente', this.$store.state.nome_rel_paciente)
            formData.append('valor', this.valor_deposito)
            formData.append('data', this.data_deposito.split(' ')[0])
            formData.append('caps_id', this.userJson.caps_id)
            if (this.comprovante_deposito[0]) {
                formData.append("comprovante", this.comprovante_deposito[0]);
            }

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/deposito', formData, config)
                .then(response => {
                    this.filtroRelComp()
                    this.adicionarComprovante = false
                    this.valor_deposito = ''
                    this.data_deposito = ''
                    this.comprovante_deposito = ''
                })
                .catch(errors => {
                    console.log(errors.response.data)
                })
        },
        carregarComprovanteDeposito(e) {
            this.comprovante_deposito = e.target.files;
            this.arquivo_carregado = this.comprovante_deposito[0].name
        },
        removerComprovante(id) {
            let confirmacao = confirm('Confirmar remoção do registro!')
            if (!confirmacao) return false
            this.load_update = true

            let formData = new FormData()
            formData.append('_method', 'delete')

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/deposito/' + id, formData, config)
                .then(response => {
                    this.filtroRelComp()
                })
                .catch(errors => {
                })
                .finally(() => {
                    this.load_update = false
                })
        },
        resetData() {
            this.ano_rel = ''
            this.mes_rel = ''
            this.resultado = {
                entrada: 0,
                saida: 0
            }
            this.totalBB = 0
        },
        resetDataDepositos() {
            this.ano_deposito = ''
            this.mes_deposito = ''
            this.valor_deposito = ''
            this.data_deposito = ''
            this.comprovante_deposito = ''
            this.arquivo_carregado = ''
            this.$store.state.depositos = {}
        },
        exportarXLSX(data) {
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Planilha");

            XLSX.writeFile(workbook, "dados.xlsx");
        },
        exportaLan() {
            this.load_update = true
            let formData = new FormData()
            formData.append('nome_paciente', this.$store.state.nome_rel_paciente)
            formData.append('cod_conta_caixa', this.$store.state.cod_conta_caixa)
            formData.append('nome_caps', this.$store.state.nome_caps)
            formData.append('data_inicio', this.inicioRel)
            formData.append('data_fim', this.fimRel)

            let config = {
                headers: {
                    'Accept': 'application/zip',
                    'Authorization': this.token
                },
                responseType: 'blob' // importante para receber o arquivo binário
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/paciente/exportar-zip', formData, config)
                .then(response => {
                    // Criar um link temporário para download
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url

                    // Nome sugerido para o arquivo
                    let fileName = `paciente_${this.$store.state.nome_rel_paciente}_${Date.now()}.zip`
                    link.setAttribute('download', fileName)

                    // Simula clique para baixar
                    document.body.appendChild(link)
                    link.click()

                    // Remove o link temporário
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(url)
                })
                .catch(error => {
                    console.error("Erro ao exportar ZIP:", error.response.data)
                    alert('Erro ao exportar ZIP: Não ha lançamento para a data selecionada.')
                })
                .finally(() => {
                    this.load_update = false
                })
        },
        parseValorBR(valor) {
            return parseFloat(valor.replace(/\./g, '').replace(',', '.'));
        },
        formatarValorBR(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        filtroRel() {
            if (this.ano_rel != '' && this.mes_rel != '') {
                let url = 'https://contasmoradores.candido.org.br/api/v1/caixinha?filtro=data_lancamento:like:' + this.ano_rel + '-' + this.mes_rel + '%;paciente_id:=:' + this.$store.state.relatorio_id

                let config = {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
                axios.get(url, config)
                    .then(response => {
                        this.$store.state.item.cx = response.data
                        this.resultado.entrada = 0
                        this.resultado.saida = 0
                        response.data.forEach(item => {
                            const valor = this.parseValorBR(item.valor_paciente);
                            if (item.tipo_operacao === 'entrada') {
                                this.resultado.entrada += valor;
                            } else if (item.tipo_operacao === 'saida') {
                                this.resultado.saida += valor;
                            }
                        });
                        this.resultado.entrada = this.formatarValorBR(this.resultado.entrada)
                        this.resultado.saida = this.formatarValorBR(this.resultado.saida)
                    })
                    .catch(errors => {
                    })
                axios.get('https://contasmoradores.candido.org.br/api/v1/lancamento?filtro=created_at:like:'
                    + this.ano_rel + '-' + this.mes_rel
                    + '%;nome_paciente:=:' + this.$store.state.nome_rel_paciente
                    + ';centro_custo_paciente:like:' + this.$store.state.centro_custo_paciente.split('.').slice(0, -1).join('.') + '%', config)
                    .then(response => {
                        this.$store.state.item.bb = response.data
                        this.totalBB = 0
                        response.data.forEach(item => {
                            const valor = this.parseValorBR(item.valor_paciente);
                            this.totalBB += valor
                        });
                    })
            }
        },
        filtroRelComp() {
            if (this.ano_deposito != '' && this.mes_deposito != '') {
                let url = 'https://contasmoradores.candido.org.br/api/v1/deposito?filtro=data:like:' + this.ano_deposito + '-' + this.mes_deposito + '%;nome_paciente:=:' + this.$store.state.nome_rel_paciente

                let config = {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
                axios.get(url, config)
                    .then(response => {
                        this.$store.state.depositos = response.data
                    })
                    .catch(errors => {
                    })
            }
        },
        filtroRelHistComp() {
            let url = ''
            if(this.userJson.nivel_acesso == 'adm') {
                url = 'https://contasmoradores.candido.org.br/api/v1/deposito?filtro=data:like:' + this.ano_deposito_hist + '-' + this.mes_deposito_hist + '%'
            } else {
                url = 'https://contasmoradores.candido.org.br/api/v1/deposito?filtro=data:like:' + this.ano_deposito_hist + '-' + this.mes_deposito_hist + '%;caps_id:=:' + this.userJson.caps_id
            }
            if (this.ano_deposito_hist != '' && this.mes_deposito_hist != '') {
                
                let config = {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
                axios.get(url, config)
                    .then(response => {
                        this.historico_depositos = response.data
                    })
                    .catch(errors => {
                    })
            }
        },
        pesquisar() {
            let filtro = ''
            for (let chave in this.busca) {
                if (this.busca[chave]) {
                    if (filtro != '') {
                        filtro += ';'
                    }
                    filtro += chave + ':like:' + this.busca[chave]
                }
            }
            if (filtro != '') {
                this.urlPaginacao = 'page=1'
                this.urlFiltro = ';' + filtro + '%'
            } else {
                this.urlFiltro = ''
            }
            this.carregarLista()
        },
        paginacao(l) {
            if (l.url) {
                this.urlPaginacao = l.url.split('?')[1]
                this.carregarLista()
            }
        },
        carregarLista() {
            let url = ''
            if (this.userJson.nivel_acesso == 'adm') {
                if (this.urlFiltro) {
                    let filtro = this.urlFiltro.split(';')
                    this.urlFiltro = '&filtro=' + filtro[1]
                }
                url = this.urlBase + '?' + this.urlPaginacao + this.urlFiltro
            } else {
                url = this.urlBase + '?' + this.urlPaginacao + '&filtro=caps_id:=:' + this.userJson.caps_id + this.urlFiltro
            }

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.pacientes = response.data
                })
                .catch(errors => {
                })
        },
        recalcularSaldos() {
            let formData = new FormData()
            formData.append('paciente_id', this.$store.state.relatorio_id)

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/recalcularsaldos', formData, config)
                .then(response => {
                    alert('Saldos Recalculados')
                    console.log(response.data)
                    this.filtroRel()
                    this.saldoAtual()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },
        saldoAtual() {
            let url = 'https://contasmoradores.candido.org.br/saldo-atual/' + this.userJson.caps_id + '/' + this.$store.state.relatorio_id
            let config = {
                headers: {
                    'Accept': 'application/json'
                }
            }
            axios.get(url, config)
                .then(response => {
                    this.$store.state.saldoRelAtual = response.data.saldo
                })
                .catch(errors => {
                })
        }
    },
    mounted() {
        this.carregarLista()
        const modalElement = document.getElementById('modalRateioCaixa');
        modalElement.addEventListener('hidden.bs.modal', this.resetData);
        const modalElementDepositos = document.getElementById('modalDepositos');
        modalElementDepositos.addEventListener('hidden.bs.modal', this.resetDataDepositos);

    },
    computed: {
        token() {
            let token = 'Bearer ' + document.cookie.split(';').find(indice => {
                return indice.includes('token=')
            }).split('=')[1]
            return token
        },

        userJson() {
            return JSON.parse(this.user);
        },
    },
}
</script>
<style>
.entrada td {
    color: green;
}

.saida td {
    color: red;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #ff6b6b, #feca57, #48dbfb, #1dd1a1);
    background-size: 800% 800%;
    animation: gradientAnimation 10s ease infinite;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0.6;
}

.spinner {
    color: #000;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

@keyframes gradientAnimation {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}
</style>